import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Flex, chakra } from '@chakra-ui/react';
import { Image } from '@/components';
import { useResolveValue } from '@/hooks';
import { useQuestionnaire } from '@/store';
import { CONFIG_STYLE, MediaSizeType } from '@/types';
import { convertToCSS } from '@/utils';
export const MediaImage = ({ block: { caption, id, media: { alignment, alt, size, src = '' }, padding } }) => {
    var _a;
    const [resolver] = useResolveValue();
    const { state: { questionnaire: { settings: { min_block_spacing = CONFIG_STYLE.PaddingType.small } = {} } = {} } } = useQuestionnaire();
    const layout = {
        alignment,
        padding: {
            bottom: (_a = padding === null || padding === void 0 ? void 0 : padding.bottom) !== null && _a !== void 0 ? _a : min_block_spacing,
            end: padding === null || padding === void 0 ? void 0 : padding.end,
            start: padding === null || padding === void 0 ? void 0 : padding.start,
            top: padding === null || padding === void 0 ? void 0 : padding.top
        }
    };
    const resolved = {
        alt: resolver.resolveString(alt),
        caption: resolver.resolveString(caption === null || caption === void 0 ? void 0 : caption.content)
    };
    const styles = {
        caption: convertToCSS(caption === null || caption === void 0 ? void 0 : caption.layout),
        fillWidth: (size === null || size === void 0 ? void 0 : size.type) === MediaSizeType.FILL_WIDTH
            ? (size === null || size === void 0 ? void 0 : size.override_screen_padding.ignore_horizontal_padding)
                ? 'fill-width ignore-horizontal-padding'
                : 'fill-width'
            : '',
        root: convertToCSS(layout)
    };
    return (_jsx(Flex, Object.assign({ sx: styles.root }, { children: _jsxs(chakra.figure, Object.assign({ className: styles.fillWidth, "data-test": id }, { children: [_jsx(Image, { alt: resolved.alt, rounded: '8', src: src, w: '100%' }), caption && (_jsx(chakra.figcaption, Object.assign({ fontSize: 'sm', sx: styles.caption, w: '100%' }, { children: resolved.caption })))] })) })));
};
